<template>
  <section class="container">
    <div class="mb-2">
      <v-alert v-if="errorMsg" type="error" :value="true">
        {{ errorMsg }}
      </v-alert>
    </div>

    <form @submit="login">
      <v-card id="login-card">
        <v-card-title>
          <h2>{{ $t('Login.login') }}</h2>
        </v-card-title>
        <v-card-text>
          <v-text-field
            ref="username"
            v-model="username"
            :error="hasErrors"
            :label="$t('Login.username')"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            :error="hasErrors"
            :label="$t('Login.password')"
            @click:append=""
            :type="isPasswordVisible ? 'text': 'password'"
            required
          >
            <template slot="append">
              <span class="visibility-button" @click="isPasswordVisible = !isPasswordVisible">
                <v-icon>{{isPasswordVisible ? 'visibility_off' : 'visibility'}}</v-icon>
              </span>
            </template>
          </v-text-field>
          <v-switch
            :label="$t('Login.staySignedIn')"
            v-model="persist"
          ></v-switch>
        </v-card-text>
        <v-card-actions class="text-md-center">
          <v-btn depressed large color="primary" class="mx-auto" :loading="isLoading" type="submit">
            {{ $t('Login.login') }} <v-icon class="ml-2">send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </section>
</template>

<script>
import i18n from '../locale';

export default {
  name: 'Login',
  data: () => {
    return {
      username: '',
      password: '',
      persist: false,
      errorMsg: '',
      isLoading: false,
      isPasswordVisible: false
    };
  },
  computed: {
    visibleIcon() {
      return this.$root.visibleIcon(this.isPinVisible);
    },
    hasErrors() {
      return this.errorMsg !== '';
    }
  },
  mounted() {
    this.$refs.username.focus();
  },
  methods: {
    login(event) {
      event.preventDefault();
      this.isLoading = true;

      this.$http.post(this.$root.route('auth'), {
        username: this.username,
        password: this.password
      })
        .then(
          // Success
          response => {
            this.isLoading = false;
            this.$emit('login', response.body.result, this.persist)
          },
          // Failure
          response => {
            this.isLoading = false;

            console.log(response);
            switch (response.status) {
              case 401:
                this.errorMsg = i18n.t('Login.invalidUserOrPwd');
                break;
              default:
                this.errorMsg = response.body.error;
                // this.errorMsg = i18n.t('Common.errorUploadInvalidResp');
                break;
            }
          }
      );
    }
  }
}
</script>

<style scoped>
  #login-card {
    max-width: 300px;
    margin: auto;
  }
  .visibility-button {
    cursor: pointer;
    user-select: none;
  }
</style>
